import { Row, Col, Image } from 'react-bootstrap';

function LeftText ({image, children}) {
    return (
        <div className='align-self-center text-left-box'>
            <Row className='flex-column-reverse flex-md-row'>
                <Col xs={12} md={3} className='text-center py-3 align-self-center'>
                   <Image src={image} className='rounded-circle text-image' />
                </Col>
                <Col className="align-self-center" xs={12} md={9}>
                    {children}
                </Col>
            </Row>
        </div>
    )
}

export default LeftText;